<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
          <div class="card" style="margin-top: -0px;"> 
            <div class="row">
              <div class="col-12">
                <div class="card-header pb-0 text-center">
                  <argon-button v-if="btnPrintShow" style="margin-left: 800px;" color="warning" size="sm" class="mb-3" variant="gradient" @click="print()"><i class="fa fa-file-pdf-o" style="margin-right: 5px;"></i> Print</argon-button>
                  <h6>SLIP GAJI - {{ moment($route.params.periode_start).locale('id').format('MMMM YYYY').toUpperCase() }}</h6>
                  <hr>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="container">
                <div class="row">
                  <div class="col-6">
                    <p style="margin-top: 10px; font-size: 15px;">ID <span style="margin-left: 70px; margin-right: 20px;">:</span> {{ slip.id_karyawan }}</p>
                    <p style="margin-top: -10px; font-size: 15px;">NAMA <span style="margin-left: 41px; margin-right: 20px;">:</span> {{ slip.nama }}</p>
                    <p style="margin-top: -10px; font-size: 15px;">JABATAN <span style="margin-left: 23px; margin-right: 20px;">:</span> {{ slip.jabatan }}</p>
                    <p style="margin-top: -10px; font-size: 15px;">STATUS <span style="margin-left: 32px; margin-right: 20px;">:</span> {{ slip.status }}</p>
                    <!-- <hr style="margin-top: 30px;"> -->
                  </div>
                  <div class="col-6 text-center">
                    <img src="../../assets/img/bck.png" width="80" />
                    <p>PT. BUANA CENTRA KARYA</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <hr>
                    PENERIMAAN
                    <hr style="margin-top: 2px;">
                    <p style="font-size: 15px;">Gaji Pokok <span style="margin-left: 63px; margin-right: 10px;">:</span> 
                      {{ convertRp(Math.round(((slip.harian == 0) ? (slip.bulanan) : (slip.harian * slip.total_kerja_count) ))) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">Tj. Jabatan / Skill <span style="margin-left: 23px; margin-right: 10px;">:</span>
                      {{ convertRp(slip.tj_jabatan_skill) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">Transport <span style="margin-left: 67PX; margin-right: 10px;">:</span> 
                      {{ convertRp(slip.transport) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">U. Makan <span style="margin-left: 70PX; margin-right: 10px;">:</span> 
                      {{ convertRp((slip.makan)) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">Tj. JKK <span style="margin-left: 93PX; margin-right: 10px;">:</span> 
                      {{ convertRp((slip.tj_jkk)) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">Tj. JKM <span style="margin-left: 90PX; margin-right: 10px;">:</span>
                      {{ convertRp((slip.tj_jkm)) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">Tj. JKS <span style="margin-left: 93PX; margin-right: 10px;">:</span>
                      {{ convertRp((slip.tj_jks)) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">Lembur <span style="margin-left: 82PX; margin-right: 10px;">:</span>
                      {{ convertRp(Math.round(slip.total_ot_count * (( (slip.unit == 'Head Quarter') || (slip.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) ))) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">Jam Lembur <span style="margin-left: 52PX; margin-right: 10px;">:</span> 
                      {{ convertRp(slip.total_ot_count) }}
                    </p>
                    <!-- <p style="margin-top: -10px; font-size: 15px;">Bonus <span style="margin-left: 92PX; margin-right: 10px;">:</span> -</p> -->
                  </div>
                  <div class="col-6">
                    <hr>
                    POTONGAN
                    <hr style="margin-top: 2px;">
                    <p style="font-size: 15px;">JHT <span style="margin-left: 105px; margin-right: 10px;">:</span> 
                      {{ convertRp(slip.jht) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">JKM <span style="margin-left: 102px; margin-right: 10px;">:</span> 
                      {{ convertRp(slip.jkm) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">JKK <span style="margin-left: 106px; margin-right: 10px;">:</span> 
                      {{ convertRp(slip.jkk) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">JP <span style="margin-left: 115px; margin-right: 10px;">:</span> 
                      {{ convertRp(slip.jp) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">JKS <span style="margin-left: 107px; margin-right: 10px;">:</span>
                      {{ convertRp(slip.jks) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">PPH21 <span style="margin-left: 85px; margin-right: 10px;">:</span>
                      {{ convertRp(slip.pph21) || 0 }}
                    </p>
                    <p style="margin-top: -10px; font-size: 12px;">Premi BPJS Kes (perusahaan, u/ pajak) <span style="margin-left: 5px; margin-right: 10px;">:</span>
                      {{ convertRp(slip.premi_bpjs_kes) || 0 }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">Lainnya <span style="margin-left: 75px; margin-right: 10px;">:</span> 
                      <span v-if="slip.rel_payroll != null">
                        {{ convertRp(Number(slip.rel_payroll.piutang) + Number(slip.rel_payroll.pinjaman)) }}
                      </span>
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;" v-if="!potonganAlpaBaru">Absensi <span style="margin-left: 75px; margin-right: 10px;">:</span>
                      <span v-if="slip.rel_payroll != null">
                        {{ convertRp(potonganAbsensi) }}
                      </span>
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;" v-else>Alpa <span style="margin-left: 95px; margin-right: 10px;">:</span>
                      {{ convertRp(potonganAlpaBaru) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;" v-if="potonganTelat">Telat <span style="margin-left: 100px; margin-right: 10px;">:</span>
                      {{ convertRp(potonganTelat) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;" v-if="potonganPulangCepat">Pulang Cepat <span style="margin-left: 50px; margin-right: 10px;">:</span>
                      {{ convertRp(potonganPulangCepat) }}
                    </p>
                    <p style="margin-top: -10px; font-size: 15px;">HK <span style="margin-left: 110px; margin-right: 10px;">:</span>
                      <span v-if="slip.rel_payroll != null">
                        {{ (+slip.total_kerja_count + +slip.total_alpa_count) }} / {{  slip.total_kerja_count }}
                      </span>
                    </p>
                  </div>
                </div>
                <hr style="margin-top: 0px;">
                <div class="row font-weight-bold">
                  <div class="col-6" style="margin-top: -10px;">
                    TOTAL <span style="margin-left: 100px; margin-right: 30px;"></span> {{ convertRp(
                      Math.round(Number(((slip.harian == 0) ? (slip.bulanan) : (slip.harian * slip.total_kerja_count) )
                      + slip.tj_jabatan_skill
                      + slip.transport
                      + slip.makan
                      + slip.tj_jkk
                      + slip.tj_jkm
                      + slip.tj_jks
                      + slip.total_ot_count * (( (slip.unit == 'Head Quarter') || (slip.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) )) )) }}
                    <hr style="margin-top: 2px;">
                  </div>
                  <div class="col-6" style="margin-top: -10px;">
                    <span v-if="slip.rel_payroll != null">
                      TOTAL <span style="margin-left: 100px; margin-right: 30px;"></span> {{ convertRp(Number(
                        slip.jht
                        + slip.jkm
                        + slip.jkk
                        + slip.jp
                        + slip.jks
                        + slip.pph21
                        + (Number(slip.rel_payroll.piutang) + Number(slip.rel_payroll.pinjaman))
                        + potonganAbsensi
                        + potonganTelat
                        + potonganPulangCepat) ) }}
                    </span>
                    <hr style="margin-top: 2px;">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-center">
                    <span v-if="slip.rel_payroll != null">
                      <p style="margin-top: 30px; font-weight: bold;">THP <span style="margin-left: 65px; "></span> <span style="border-bottom: 3px double;">
                        {{ convertRp(Math.round(
                          Number(((slip.harian == 0) ? (slip.bulanan) : (slip.harian * slip.total_kerja_count) )
                          + slip.tj_jabatan_skill
                          + slip.transport
                          + slip.makan
                          + slip.tj_jkk
                          + slip.tj_jkm
                          + slip.tj_jks
                          + 1
                          + slip.total_ot_count * (( (slip.unit == 'Head Quarter') || (slip.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) ))
                          -
                          ((Number(slip.rel_payroll.piutang) + Number(slip.rel_payroll.pinjaman))
                          + Number(slip.jht + slip.jkm + slip.jkk + slip.jp + slip.jks)
                          + slip.pph21
                          + potonganAbsensi
                          + potonganTelat
                          + potonganPulangCepat) )) }}
                      </span></p>
                    </span>
                  </div>
                </div>
                    <p style="margin-left: 58px; margin-top: 70px; margin-bottom: 80px;">Payroll</p>
                    <span style="border-bottom: 3px double; margin-left: 35px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <hr style="margin-top: 30px;">
              </div>
              <div class="card-footer">
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/helpers/api';
import dataPayroll from '@/services/dataPayroll.service';
var moment = require('moment');
import ArgonButton from "@/components/ArgonButton.vue";

export default {
  name: "tables",
  components: {
    ArgonButton,
  },
  data() {
    return {
      moment:moment,
      table: {
        data: []
      },
      form: {
        add: true,
        title: "Add Data",
        show: false
      },
      slip: {},
      search: '',
      btnPrintShow: true,
    };
  },
  computed: {
    // slip.potongan_keterlambatan comes from the backend (PayrollController@show)
    // -- admin-configured rates (Setting Potongan) x attendance data, 0 by
    // default so nothing changes until Admin sets real rates.
    potonganTelat() {
      return this.slip.potongan_keterlambatan ? Number(this.slip.potongan_keterlambatan.potongan_telat) : 0;
    },
    potonganPulangCepat() {
      return this.slip.potongan_keterlambatan ? Number(this.slip.potongan_keterlambatan.potongan_pulang_cepat) : 0;
    },
    potonganAlpaBaru() {
      return this.slip.potongan_keterlambatan ? Number(this.slip.potongan_keterlambatan.potongan_alpa) : 0;
    },
    // The line actually used in TOTAL/THP for the alpa deduction -- the new
    // configurable rate once Admin sets one, otherwise the original
    // (bulanan / 22) x hari alpa formula this page always used.
    potonganAbsensi() {
      if (this.potonganAlpaBaru) return this.potonganAlpaBaru;
      if (!this.slip.rel_payroll) return 0;
      return Math.round(((this.slip.harian == 0) ? ((this.slip.bulanan / 22) * this.slip.total_alpa_count) : 0));
    },
  },
  mounted(){
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
    window.onafterprint = function(){
      location.reload()
    }
  },
  methods: {
    get(){
      let context = this;               
      Api(context, dataPayroll.show({id_karyawan: context.$route.params.id_karyawan, periode_start: context.$route.params.periode_start, periode_end: context.$route.params.periode_end,})).onSuccess(function(response) {    
          context.slip = response.data.data;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
      })
      .call()
    },
    convertRp(bilangan) {
      if (bilangan) {
        var number_string = bilangan.toString(),
            sisa    = number_string.length % 3,
            rupiah  = number_string.substr(0, sisa),
            ribuan  = number_string.substr(sisa).match(/\d{3}/g);

        if(ribuan){
          var separator = sisa ? '.' : '';
          rupiah += separator + ribuan.join('.');
          return rupiah
        }else{
          return bilangan
        }
      }
    },
    print(){
      this.btnPrintShow = false;
      setTimeout(function () {
        window.print();
      },1000); // 5 seconds
    },
    printClose(){
      this.btnPrintShow = true
      alert('ok')
    }
  },
  beforeMount() {
    // this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = false;
    // this.$store.state.hideConfigButton = true;
    // body.classList.add("profile-overview");
  },
  beforeUnmount() {
    // this.$store.state.isAbsolute = false;
    // this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = false;
    // this.$store.state.hideConfigButton = false;
    // body.classList.remove("profile-overview");
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll { 
  overflow: auto; 
  height: 500px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #F0F8FF;
}
</style>
